import { render, staticRenderFns } from "./OnMap.vue?vue&type=template&id=5b36e598"
import script from "./OnMap.vue?vue&type=script&lang=js"
export * from "./OnMap.vue?vue&type=script&lang=js"
import style0 from "./OnMap.vue?vue&type=style&index=0&id=5b36e598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports